<template>
  <div class="appeal-type-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>诉求分类管理</span>
        <el-button type="primary" size="small" style="float: right;" @click="openAddDialog">
          新增分类
        </el-button>
      </div>
      <el-table v-loading="loading" :data="typeList" border style="width: 100%">
        <el-table-column prop="typeCd" label="分类编码" align="center" />
        <el-table-column prop="typeName" label="分类名称" align="center" />
        <el-table-column prop="seq" label="排序" align="center" />
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip />
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="typeForm" :model="typeForm" :rules="typeRules" label-width="90px">
        <el-form-item label="分类编码" prop="typeCd">
          <el-input v-model="typeForm.typeCd" placeholder="请输入分类编码" :disabled="isEdit" />
        </el-form-item>
        <el-form-item label="分类名称" prop="typeName">
          <el-input v-model="typeForm.typeName" placeholder="请输入分类名称" />
        </el-form-item>
        <el-form-item label="排序" prop="seq">
          <el-input-number v-model="typeForm.seq" :min="0" controls-position="right" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="typeForm.remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitType">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listAreaAppealTypes,
  saveAreaAppealType,
  updateAreaAppealType,
  deleteAreaAppealType
} from '@/api/community/areaAppealTypeApi'

export default {
  name: 'AreaAppealTypeList',
  data() {
    return {
      loading: false,
      typeList: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增分类',
      typeForm: {
        id: '',
        typeCd: '',
        typeName: '',
        seq: 0,
        remark: ''
      },
      typeRules: {
        typeCd: [
          { required: true, message: '请输入分类编码', trigger: 'blur' }
        ],
        typeName: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isEdit() {
      return !!this.typeForm.id
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      listAreaAppealTypes({
        page: this.page.current,
        row: this.page.size
      }).then(res => {
        this.typeList = res.data || []
        this.page.total = res.total || 0
      }).catch(error => {
        this.$message.error(error.message || '获取分类列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    openAddDialog() {
      this.dialogTitle = '新增分类'
      this.typeForm = {
        id: '',
        typeCd: '',
        typeName: '',
        seq: 0,
        remark: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.typeForm.clearValidate()
      })
    },
    openEditDialog(row) {
      this.dialogTitle = '编辑分类'
      this.typeForm = {
        id: row.id,
        typeCd: row.typeCd,
        typeName: row.typeName,
        seq: row.seq,
        remark: row.remark
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.typeForm.clearValidate()
      })
    },
    submitType() {
      this.$refs.typeForm.validate(valid => {
        if (!valid) return
        const api = this.isEdit ? updateAreaAppealType : saveAreaAppealType
        api(this.typeForm).then(() => {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
          this.dialogVisible = false
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '操作失败')
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该分类？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAreaAppealType({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '删除失败')
        })
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.appeal-type-container {
  padding: 20px;

  .el-card {
    margin-bottom: 20px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
